export default {"src":"/_next/static/media/investor_icon.8a91990b.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};